module.exports = __webpack_public_path__ + "static/media/icon_add.2b14cf54.svg";